import { FC, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import { ULoading, UTextField } from "@/components/index"
import { UButton } from "@/components/index"
import { wasmModule } from "@/gluelayer"
import { setOpenTrimPreview } from "@/UDTreat/udTreatSlice"
import {
  EPrintModel,
  IPrintSettingJsonObj,
} from "@/core/app/slices/user/user.type"
export const TrimLine: FC<{
  exportModel: EPrintModel
  jsonData: IPrintSettingJsonObj
  updateJsonData: (data: IPrintSettingJsonObj) => void
}> = ({ exportModel, jsonData, updateJsonData }) => {
  const { openTrimPreview } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const dispatch = useAppDispatch()
  const [trimValue, setTrimValue] = useState<number>(null)
  // trim line value
  const handleTrimValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateJsonData({
      UseuContourMachine: parseInt((event.target as HTMLInputElement).value),
    })
  }
  const [isloading, setIsloading] = useState(false)

  useEffect(() => {
    if (
      exportModel === EPrintModel.LuxcreoModel ||
      exportModel === EPrintModel.DPAModel
    ) {
      updateJsonData({ UseuContourMachine: 3 })
    }
  }, [exportModel])
  useEffect(() => {
    if (!jsonData) {
      return
    }
    const UseuContourMachine = jsonData.UseuContourMachine
    setTrimValue(UseuContourMachine??0)
  }, [jsonData])
  useEffect(() => {
    try {
      // machine to wasm
      const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
      if (printMoudle && trimValue) {
        printMoudle.SetTrimMachineSlotType(trimValue.toString())
      }
    } catch (error) {
      console.error(error)
    }
  }, [trimValue])
  // set preview canvas window height
  // preview button disabled boolean
  const [previewButtonDisabled, setPreviewButtonDisabled] =
    useState<boolean>(true)
  useEffect(() => {
    try {
      const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
      if (!printMoudle) return
      const trimBool = printMoudle.GetButtonHookStartAndEndAtSameStage()
      setPreviewButtonDisabled(trimBool)
    } catch (error) {
      console.log(error)
    }
  }, [wasmModule.moduleManager.GetModulePrintSelection()])
  return (
    <Box sx={{ width: "100%" }}>
      <FormControl
        sx={{ marginRight: "240px" }}
        disabled={
          exportModel === EPrintModel.LuxcreoModel ||
          exportModel === EPrintModel.DPAModel
        }
      >
        <FormLabel id="toothPosition">{`Trim Machine`}</FormLabel>
        <RadioGroup
          sx={{ marginLeft: "10px" }}
          aria-labelledby="toothPosition"
          name="radio-buttons-group"
          value={trimValue}
          onChange={handleTrimValue}
        >
          <FormControlLabel
            value={2}
            control={<Radio />}
            label="Digital Dental Trimming Machine"
          />
          <FormControlLabel
            value={3}
            control={<Radio />}
            label="General Trimming Machine(No mounting fixture at bottom of model)"
          />
          {/* <FormControlLabel
            value={5}
            control={<Radio />}
            label="DPA ( Direct Print Aligner)"
          />
          <FormControlLabel value={4} control={<Radio />} label="LuxCreo" /> */}
          <FormControlLabel
            value={1}
            control={<Radio />}
            label="No Trim Machine(No output trim line data output)"
          />
        </RadioGroup>
      </FormControl>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "strat",
          marginTop: "24px",
        }}
      >
        <UButton
          sxProp={{
            color: "#212121",
            height: "36px",
            width: "176px",
            borderRadius: "4px",
            background: "#DADCDD !important",
            boxShadow:
              "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
            padding: "6px 16px",
          }}
          variant={"contained"}
          btnText={`Trim Line Preview`}
          disabled={!previewButtonDisabled || +trimValue === 1}
          onClickHandler={() => {
            // open trim preview
            const printMoudle =
              wasmModule.moduleManager.GetModulePrintSelection()
            if (!openTrimPreview) {
              if (printMoudle && printMoudle.OnCuttingLinePreviewButtonDown) {
                setIsloading(true)
                setTimeout(() => {
                  printMoudle.OnCuttingLinePreviewButtonDown()
                  // open trimline preview ui
                  dispatch(setOpenTrimPreview(true))
                  setIsloading(false)
                }, 200)
              }
            } else {
              printMoudle.ApplyInPreview()
              printMoudle.GoToOrigin3DScene()
              dispatch(setOpenTrimPreview(false))
            }
          }}
        />
      </Box>
      <ULoading isLoading={isloading} />
    </Box>
  )
}
